export const navItems = [
  {
    id: "nts-pricing",
    name: "Pricing",
    link: "",
  },
  {
    id: "nts-faq",
    name: "FAQ",
    link: "",
  },
  {
    id: "nts-contact",
    name: "Contact Us",
    link: "",
  },
];
